<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
    >
      <v-card-title class="pa-2 d-flex justify-space-between">
        {{ $t('requests.title') }}
        <v-btn fab small @click="showCreateDialog()">
          <v-icon v-if="isFirst" color="green" x-large>mdi-account-plus</v-icon>
          <v-icon v-else>mdi-account-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-list dense two-line class="px-2">
          <v-list-item v-for="(c, i) in sortedRequests" :key="i" class="litem px-0">
            <v-list-item-content>
              <v-list-item-title class="title">{{getNick(c.nick, c.pid)}}</v-list-item-title>
              <v-list-item-subtitle>
                <span class="white--text ml-2">{{formatDateDiff(c.time)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon disabled v-if="c.state === 'W'" class="px-2">mdi-account-clock-outline</v-icon>
              <v-icon color="green" v-if="c.state === 'C'" class="px-2">mdi-check-circle-outline</v-icon>
              <v-icon color="red" v-if="c.state === 'R'" class="px-2">mdi-cancel</v-icon>
              <v-icon v-if="c.state === 'A'" @click="approveRequest(c.nick, c.pid)" class="px-2">mdi-check-circle-outline</v-icon>
              <v-icon @click="deleteRequest(c.pid)">mdi-close-circle</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <!-- create dialog -->
    <v-dialog v-model="dialogCreateRequest" scrollable persistent max-width="350" light>
      <v-card>
        <v-card-title class="d-flex justify-space-between px-3 pt-2">
            {{ $t('requests.dialogTitle')}}
            <v-icon class="float-right" @click="dialogCreateRequest = false">mdi-close</v-icon>
            <v-row justify="center" align="center" class="ma-2">
              <v-col cols="10" class="ma-0 pa-0">
                <v-text-field
                  v-model="query"
                  :counter="100"
                  :label="$t('requests.query')"
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="ma-0 pa-0">
                <v-icon class="float-right" @click="search()">mdi-magnify</v-icon>
              </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list dense class="px-0">
            <v-list-item v-for="(c, i) in sortedSearchResults" :key="i" class="litem px-0">
              <v-list-item-content>
                <v-list-item-title class="">{{getNick2(c.nick, c.pid)}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon @click="sendRequest(c.nick, c.pid)">mdi-email-send-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" small @click="dialogCreateRequest = false">{{ $t('app.btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'Requests',
  components: {
  },
  data: () => ({
    dialogCreateRequest: false,
    query: '',
    valid: false
  }),
  computed: mapGetters(['sortedRequests','getNickOrPid','sortedSearchResults', 'isFirst']),
  async mounted() {
    try {
      await this.$store.dispatch('loadRequests')
      if (this.isFirst) {
          var self = this
          setTimeout(function() {
            self.$store.commit('first', false);
          }, 1000);
      }
    } catch (err) {
        this.$emit('error', this.$t('requests.errLoad'))
    }
  },
  methods: {
    showCreateDialog() {
      this.query = ''
      this.dialogCreateRequest = true
      this.$store.dispatch('clearSearch')
    },
    async search() {
      if (this.query) {
        try {
          await this.$store.dispatch('search', this.query)
        } catch (err) {
            this.$emit('error', this.$t('requests.errSearch'))
        }
      }
    },
    async sendRequest(nick, pid) {
      try {
        await this.$store.dispatch('sendRequest', {nick: nick, pid: pid})
        if (this.notEmpty(nick)) {
          this.$store.commit('addNick', {nick: nick, pid: pid})
        }
      } catch (err) {
          this.$emit('error', this.$t('requests.errSend'))
      }
      this.dialogCreateRequest = false
    },
    async approveRequest(nick, pid) {
      try {
        await this.$store.dispatch('approveRequest', pid)
        this.$emit('info', this.$t('requests.infoApproved'))
        this.$emit('toSynchronize')
        if (this.notEmpty(nick)) {
          this.$store.commit('addNick', {nick: nick, pid: pid})
        }
        this.$router.push({ path: '/connections'})
      } catch (err) {
          this.$emit('error', this.$t('requests.errApproved'))
      }
    },
    async deleteRequest(pid) {
      try {
        await this.$store.dispatch('deleteRequest', pid)
        this.$emit('toSynchronize')
      } catch (err) {
          this.$emit('error', this.$t('requests.errDelete'))
      }
    },
    getNick(nick, pid) {
      if (nick && nick !== '')  {
        return nick
      } else {
        return pid
      }
    },
    getNick2(nick, pid) {
      if (nick && nick !== '')  {
        return nick + ' (' + pid.substring(0, 4) + '...)'
      } else {
        return pid
      }
    }
  }
}
</script>
<style>
.litem {
  /* border-top: 1px solid grey; */
}
</style>
